import { action, computed, observable } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import * as DocumentManagement from "../DocumentManagement";
import { FolderIcon } from "../Icons/FolderIcon";
import { DocumentStoreImpl } from "../Stores/DocumentStore";

interface IHierarchyMetaValueSelectionBase {
	updateConfirmButton: () => void;
	documentStore?: DocumentStoreImpl;
}

interface IHierarchyMetaValueSelection extends IHierarchyMetaValueSelectionBase {
	values: DocumentManagement.HierarchyValue[];
}

@observer
export class HierarchyMetaValueSelection extends React.Component<IHierarchyMetaValueSelection, {}> {

	render() {
		return <div className="wizardbox-content search--toolbar">
			<div className="wizardbox-module">
				<DocumentMetaSelectionList values={this.props.values} updateConfirmButton={this.props.updateConfirmButton} />
			</div>
		</div>;
	}
}

@inject('documentStore')
@observer
class DocumentMetaSelectionList extends React.Component<IHierarchyMetaValueSelection, {}> {

	store: DocumentStoreImpl;

	componentWillMount() {
		this.store = this.props.documentStore;
		this.props.updateConfirmButton();
	}

	render() {
		return <div className="list-simple">
			<ul>
				{
					this.props.values.map(item => <DocumentMetaSelectionListItem key={item.value} item={item} level={0} updateConfirmButton={this.props.updateConfirmButton} />)
				}
			</ul>
		</div>;
	}
}

interface IHierarchyMetaValueSelectionListItemProps extends IHierarchyMetaValueSelectionBase {
	item: DocumentManagement.HierarchyValue;
	level: number;
}


@inject('documentStore')
@observer
class DocumentMetaSelectionListItem extends React.Component<IHierarchyMetaValueSelectionListItemProps, {}> {

	store: DocumentStoreImpl;

	@observable isOpen: boolean;

	componentWillMount() {
		this.store = this.props.documentStore;
		this.props.updateConfirmButton();
	}

	@action handleClickItem = () => {
		this.isOpen = !this.isOpen;
		if (this.store.selectedHierarchyMetaValue !== this.props.item.value) {
			this.store.selectedHierarchyMetaValue = this.props.item.value;
		}
		this.props.updateConfirmButton();
	}

	@computed get containsSearchTerm() {
		return this.props.item.value.toLowerCase().search(this.store.hierarchyMetaValueWizardStore.searchTerm.toLowerCase()) > -1
	}

	@computed get itemClass() {
		let className = "hierarchyitem";
		if (this.store.selectedHierarchyMetaValue === this.props.item.value) {
			className += " is--selection-selected"
		}
		if (this.store.hierarchyMetaValueWizardStore.searchTerm && this.containsSearchTerm) {
			className += " currentResult";
		}
		return className;
	}

	@computed get display() {
		return !this.store.hierarchyMetaValueWizardStore.searchTerm || this.containsSearchTerm || this.childrenContainSearchTerm(this.props.item.children);
	}

	@computed get showChildren() {
		return this.isOpen || (this.store.hierarchyMetaValueWizardStore.searchTerm && this.childrenContainSearchTerm(this.props.item.children));
	}

	childrenContainSearchTerm(values: DocumentManagement.HierarchyValue[]): boolean {
		return !this.store.hierarchyMetaValueWizardStore.searchTerm || values.some(v => v.value.toLowerCase().search(this.store.hierarchyMetaValueWizardStore.searchTerm.toLowerCase()) > -1 || this.childrenContainSearchTerm(v.children));
	}

	render(): JSX.Element {
		let showFolder = this.props.item.children && this.props.item.children.length > 0;
		return this.display ? <>
			<li className={this.itemClass} onClick={this.handleClickItem} style={{ marginLeft: this.props.level * 20 + (!showFolder ? 21 : 0) }}>
				<a>
					<span>
						{showFolder ? <FolderIcon /> : null}
						{this.props.item.value}
					</span>
				</a>
			</li>
			{this.showChildren && this.props.item.children && this.store.hierarchyMetaValueWizardStore.isOpen ? this.props.item.children.map(child => <DocumentMetaSelectionListItem key={child.value} item={child} level={this.props.level + 1} updateConfirmButton={this.props.updateConfirmButton} />) : null}
		</> : null;
	}
}
